import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const Content = styled(Flex)`
    flex-direction: column;
    gap: 4px;
`;
export const AddonsList = styled(Flex)`
    flex-direction: column;
    gap: 10px;
`;
export const Addon = styled(Flex)`
    justify-content: space-between;
    align-items: flex-start;
`;
export const AddonPrice = styled(Flex)`
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    min-width: 45px;
`;
